// extracted by mini-css-extract-plugin
export var infoItem = "_se-2";
export var title = "_se-0";
export var value = "_se-1";